import React, { useState, useEffect } from "react";
import {
  useNegotiationChatApiQuery,
  useNegotiationAccRejMutation,
  useNegotiationCreatedMutation,useGetSellerAddressInfoQuery
} from "./ProcurementApiSlice";
import { Spinner } from "react-bootstrap";
import { Label } from "reactstrap";
import Button from "@mui/material/Button";
import { toast } from "react-toastify";
import Swal from 'sweetalert2';
import Skeleton from "react-loading-skeleton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateLeft } from "@fortawesome/free-solid-svg-icons";

export default function SellerIndependentNegotiationModal({
  negotiationItem,
  setNegotiationModal,
  user_id,
  BuyersList,
  UserType,
  refetch,
  setWidth,stockId
}) {
  const id = negotiationItem.id;
  const {
    data: getNegotiationChat,    isLoading,
    refetch: refetchChat,
  } = useNegotiationChatApiQuery({id:id,user_id:user_id});
  // const {
  //   data: getAddress,
  // } = useGetSellerAddressInfoQuery(stockId);
  const [acceptNegotiation,  ] = useNegotiationAccRejMutation();
  const [negotiationCreated,  ] = useNegotiationCreatedMutation();
  const [loading, setLoading] = useState(false);
  const [negotiationStatus, setNegotiationStatus] = useState("");
  const [negotiatioanValues, setNegotiationValue] = useState({
    price: negotiationItem.price,
    quantity: negotiationItem.quantity,
    procurement: negotiationItem.id,
    message: "",
    send_to: negotiationItem.created_by,
  });
  const [chatHistory, setChatHistory] = useState([]);
  const [showFields, setShowFields] = useState(false);
  const [loadingAccepted, setLoadingAccepted] = useState(false);
  useEffect(() => {
    if (getNegotiationChat) {
      setChatHistory(getNegotiationChat?.data);
      if(getNegotiationChat?.data && getNegotiationChat?.data.length>0){
        const lastValue = getNegotiationChat?.data[getNegotiationChat?.data.length - 1];
        setNegotiationValue({
          price: lastValue?.price,
          quantity: lastValue?.quantity,
          procurement: negotiationItem.id,
          message: "",
          send_to: negotiationItem.created_by,
        });
      }
    }
  }, [getNegotiationChat]);

 
  const handleAccepted = (val) => {
    setNegotiationStatus(val);
    // Show a confirmation dialog using SweetAlert
    Swal.fire({
      title: 'Are you sure?',
      text: `You want to ${val==="Accepted" || val==="Negotiation Accepted"?"Accept":"Reject"} this Deal at price ${negotiatioanValues.price} for quantity ${negotiatioanValues.quantity}?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.isConfirmed) {
        // User clicked 'Yes', proceed with the API call
        let payload = {
          status: val,
          entity_type: UserType,
          user_id: user_id,
          final_quantity: negotiatioanValues.quantity,
          final_price: negotiatioanValues.price,
        };
        let id = negotiationItem.id;
        acceptNegotiation({ id, payload })
          .unwrap()
          .then(async (data) => {
            toast.success(`Trade ${val} Successfully`);
            await refetch();
            setNegotiationModal(false);
            setWidth(false)
            setLoadingAccepted(false);
          })
          .catch((error) => {
            toast.error(error?.data?.message);
            setLoadingAccepted(false);
          });
      } else {
        // User clicked 'No' or closed the dialog
      }
    });
  };

  const handleChange = (e) => {
    setNegotiationValue({
      ...negotiatioanValues,
      [e.target.name]: e.target.value,
    });
  };
  const handleOk = (e) => {
    e.preventDefault();
    if(negotiatioanValues.quantity>negotiationItem?.quantity)
      {
      Swal.fire({
        title: `Negotiation Quantity cannot be greater then ${negotiationItem.quantity} ${negotiationItem.unit_of_measure}`,
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancel",
        confirmButtonIcon: "fas fa-arrow-right",
      })
       return
      }
    setLoading(true);
    let payload = {
      ...negotiatioanValues,
      send_from: user_id,
      entity_type: UserType,
    };
    negotiationCreated(payload)
      .unwrap()
      .then(async (data) => {
        toast.success(`Trade Negotiated Successfully`);
        //   setNegotiationModal(false)
        await refetch()
        setNegotiationModal(false);
        setWidth(false)
        setLoading(false);
        refetchChat();
      })
      .catch((error) => {
        toast.error(error?.data?.message);
        setLoading(false);
        return;
      });
  };
  return (
    <div>
    
       <div
  style={{
    borderRadius: '8px',
    lineHeight: '1.6',
  }}
>
  <div
    style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      margin: '10px 0',
    }}
  >
    <div>
      <b>Quoted Price :</b>{' '}
      <span style={{ color: 'orange' }}>₹ {negotiationItem?.price}</span>
    </div>
    <div>
      <b>Quoted Quantity :</b>{' '}
      <span style={{ color: 'orange' }}>{negotiationItem?.quantity} {BuyersList?.unit_of_measure}</span>{' '}
    </div>
  </div>
  <div
    style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      margin: '10px 0',
    }}
  >
    <div>
      <b>Payment Type :</b>{' '}
      <span style={{ color: 'orange' }}>
        {negotiationItem?.delivery_and_payment_detail?.payment_type}
      </span>
    </div>
    <div>
      <b>Delivery Timeline :</b>{' '}
      <span style={{ color: 'orange' }}>
        {negotiationItem?.delivery_and_payment_detail?.delivery_timeline} Days
      </span>
    </div>
  </div>

  {/* Payment Timeline (Conditional) */}
  {negotiationItem?.delivery_and_payment_detail?.payment_type === 'D+' && (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        margin: '10px 0',
      }}
    >
      <div>
        <b>Payment Timeline :</b>{' '}
        <span style={{ color: 'orange' }}>
          {negotiationItem?.delivery_and_payment_detail?.payment_timeline} Days
        </span>
      </div>
    </div>
  )}
</div>
        <button onClick={() =>refetchChat()} style={{ float: "right" }}>
               <FontAwesomeIcon icon={faRotateLeft} />
             </button>
      <section class="msger ">
      {isLoading?<Skeleton count={7}/>

        :chatHistory.length > 0 ? (
          <div className="heightChat">
            {chatHistory?.map((data, index) => {
              return (
                <main class="msger-chat">
                  {data.entity_type === UserType ? (
                    <div class="msg right-msg">
                      <div
                        class="msg-img"
                        style={{
                          backgroundImage:
                            "url(https://image.flaticon.com/icons/svg/145/145867.svg)",
                        }}
                      ></div>

                      <div class="msg-bubble">
                        <div class="msg-info">
                          <div class="msg-info-name text-primary">
                            {UserType==="Buyer"?negotiationItem.buyer_name:negotiationItem.seller_name}
                          </div>
                        </div>

                        <div class="msg-info">
                          <div class="msg-info-time">
                            <b>Price/Unit : ₹ {data.price}</b>
                          </div>
                          <div class="msg-info-time mx-3">
                            <b>
                              Qty : {data.quantity}{" "}
                              {negotiationItem.unit_of_measure}
                            </b>
                          </div>
                        </div>
                        <div class="msg-text">{data.message}</div>

                        <div class="msg-info">
                          <div
                            class="msg-info-name text-primary "
                            style={{ visibility: "hidden" }}
                          >
                            {data.entity_type}
                          </div>
                          <div class="msg-info-time text-gray mt-1">
                            {data.created_at.slice(0, 10)}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div class="msg left-msg">
                      <div
                        class="msg-img"
                        style={{
                          backgroundImage:
                            "url(https://image.flaticon.com/icons/svg/327/327779.svg)",
                        }}
                      ></div>

                      <div class="msg-bubble">
                        <div class="msg-info">
                          <div class="msg-info-name text-primary">
                            {UserType==="Buyer"?negotiationItem.seller_name:negotiationItem.buyer_name}

                          </div>
                        </div>

                        <div class="msg-info">
                          <div class="msg-info-time">
                            <b>Price/Unit : ₹ {data.price}</b>
                          </div>
                          <div class="msg-info-time mx-3">
                            <b>
                              Qty : {data.quantity}{" "}
                              {negotiationItem.unit_of_measure}
                            
                            </b>
                          </div>
                        </div>
                        <div class="msg-text">{data.message}</div>
                        <div class="msg-info">
                          <div
                            class="msg-info-name text-primary "
                            style={{ visibility: "hidden" }}
                          >
                            {data.entity_type}
                          </div>
                          <div class="msg-info-time text-gray mt-1">
                            {data.created_at.slice(0, 10)}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </main>
              );
            })}
          </div>
        ) : (
          ""
        )}
        {negotiationItem?.negotiation_detail?.is_expired?
              <div>
              <hr />
              <h5 className="mb-4">
                <div className="msg-info mx-3">
                  <div className="checkingcss">
                   Negotiation Expired.
                  </div>
                </div>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={() => setNegotiationModal(false)}
                  className="float-end mb-4 mt-2 me-3">
                  Close
                </Button>
              </h5>
            </div>
        :<>
        {negotiationItem.is_seller_agreed ||
      negotiationItem?.status === "Rejected" || negotiationItem?.status === "Negotiation Rejected" || negotiationItem.status==="Closed"
         ? (
          <div>
            <hr />
            <h5 className="mb-4">
              <div className="msg-info mx-3">
                <div>
                  <span
                    className={
                      negotiationItem?.status === "Rejected"
                        ? "checkingcss"
                        : "text-successs"
                    }
                  >
                    {negotiationItem?.status} 
                  </span>
                  &nbsp;at ₹ {negotiatioanValues.price} for quantity{" "}
                  {negotiatioanValues.quantity} {BuyersList.unit_of_measure} .
                </div>
                <div className=""> </div>
              </div>
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={() => setNegotiationModal(false)}
                className="float-end mb-4 mt-2 me-3"
              >
                Close
              </Button>
            </h5>
          </div>
        ) : (
          <form onSubmit={handleOk}>
            <div className="row mt-3">
              {showFields ? (
                <>
                  <div className="col-lg-5 form-group mb-2 text_box mx-3">
                    <Label className="f_p text_c f_400">
                      Quantity ({negotiationItem.unit_of_measure})
                      <small className="text-danger">*</small>
                    </Label>
                    <input
                      name="quantity"
                      type="number"
                      className="msger-inputText "
                      value={negotiatioanValues.quantity}
                      placeholder="Enter Quantity"
                      style={{
                        border: "2px solid #807474",

                        textIndent: "15px",
                        fontSize: "14px",
                        backgroundColor:"white"

                      }}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-lg-5 form-group mb-2 text_box mx-3">
                    <Label className="f_p text_c f_400">
                      Price/Unit (₹) <small className="text-danger">*</small>
                    </Label>
                    <input
                      name="price"
                      type="text"
                      value={negotiatioanValues.price}
                      className="msger-inputText "
                      style={{
                        border: "2px solid grey",
                        textIndent: "15px",
                        fontSize: "14px",
                        backgroundColor:"white"

                      }}
                      placeholder="Enter Price"
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <h6 className="mx-4 mt-1">Total Price : ₹ {negotiatioanValues.quantity * negotiatioanValues.price}</h6>
                  <div className="col-lg-12 form-group mb-2 text_box mt-2">
                    <div className="msger-inputarea">
                      <input
                        type="text"
                        className="msger-input"
                        placeholder="Enter your message..."
                        onChange={handleChange}
                        name="message"
                      />
                      <button className="msger-send-btn" type="submit">
                        OK {loading ? <Spinner size="sm" /> : ""}
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
              <div className="text-center mt-2 mb-4">
                {showFields ? (
                  ""
                ) : (
                  <>
                    <Button
                      variant="contained"
                      color="success"
                      size="small"
                      onClick={() => handleAccepted(UserType==="Seller"?"Negotiation Accepted":"Accepted")}
                      className="mx-2"
                    >
                      Accept &nbsp;{loadingAccepted?<Spinner size="sm"/>:""}
                    </Button>
                    <Button
                      variant="contained"
                      color="error"
                      size="small"
                      onClick={() => handleAccepted("Negotiation Rejected")}
                      className="mx-2"
                    >
                      Reject
                    </Button>
                    <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => setShowFields(true)}
                  >
                    Negotiate
                  </Button>
                  </>
                )}
               
              </div>
            </div>
          </form>
        )}
        </>}
      </section>
    
    </div>
  );
}
